import { render, staticRenderFns } from "./nextState.vue?vue&type=template&id=73878f48&scoped=true"
import script from "./nextState.vue?vue&type=script&lang=js"
export * from "./nextState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73878f48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73878f48')) {
      api.createRecord('73878f48', component.options)
    } else {
      api.reload('73878f48', component.options)
    }
    module.hot.accept("./nextState.vue?vue&type=template&id=73878f48&scoped=true", function () {
      api.rerender('73878f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersale/nextState.vue"
export default component.exports